import { useEffect, useState } from 'react';

export const useFormValues = ({ exchangeData }) => {
  const initializeFormValues = () => {
    const initialEntries = exchangeData.entries
      .filter(entry => entry.selected)
      .map(entry => ({
        lineNumber: entry.originalOrderEntry.entryNumber,
        reason: entry.exchangeReason || '',
      }));
    return { entries: initialEntries };
  };

  const [formValues, setFormValues] = useState(initializeFormValues);

  useEffect(() => {
    setFormValues(initializeFormValues());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exchangeData]);

  return { formValues, setFormValues };
};
